import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "../data/services";
import { Eyebrow, Reveal } from "../lib/ui";

export const YdelserPage = () => {
  const navigate = useNavigate();
  return (
    <main data-testid="ydelser-page" className="pb-20 pt-28 sm:pt-36">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Ydelser</Eyebrow>
          <h1 className="mt-4 max-w-2xl text-4xl font-semibold tracking-[-0.02em] text-slate-900 sm:text-5xl">
            Vores ydelser — klart opdelt, så du nemt finder din sag
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            Vi har samlet alt, hvad vi hjælper med — i fire overblikkelige områder. Vælg
            ydelsen, der matcher din situation, eller kontakt os, hvis du er i tvivl.
          </p>
        </Reveal>

        {CATEGORIES.map((c, ci) => (
          <Reveal key={c.slug} delay={ci * 0.04}>
            <div className="mt-14">
              <div className="flex items-end justify-between gap-4 border-b border-slate-200 pb-4">
                <h2 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">{c.title}</h2>
                <button
                  data-testid={`ydelser-category-${c.slug}`}
                  onClick={() => navigate(`/ydelser/${c.slug}`)}
                  className="group inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600"
                >
                  Se området
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </button>
              </div>
              <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {c.items.map((p) => (
                  <div
                    key={p.slug}
                    role="link"
                    tabIndex={0}
                    data-testid={`ydelser-item-${p.slug}`}
                    onClick={() => navigate(`/ydelser/${p.slug}`)}
                    onKeyDown={(e) => e.key === "Enter" && navigate(`/ydelser/${p.slug}`)}
                    className="group cursor-pointer rounded-3xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand-600/50 hover:shadow-xl hover:shadow-slate-900/5"
                  >
                    <h3 className="text-lg font-semibold tracking-tight text-slate-900">{p.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.short}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600">
                      Læs mere
                      <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.2}>
          <div
            data-testid="ydelser-inkasso-band"
            className="mt-14 rounded-3xl border border-dashed border-slate-300 bg-slate-50/60 p-6 sm:p-8"
          >
            <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
              <div className="max-w-xl">
                <h2 className="text-2xl font-semibold tracking-tight text-slate-900">Inkasso</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  Inkassosager håndterer vi ikke selv — de varetages af vores
                  samarbejdspartner Arrea. Klik videre, hvis din sag handler om ubetalte
                  fordringer.
                </p>
              </div>
              <a
                href="https://arrea.dk"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="ydelser-item-inkasso"
                className="group inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-brand-950 px-7 py-3.5 text-base font-semibold text-white shadow-lg shadow-brand-950/30 transition-all duration-200 hover:bg-brand-900"
              >
                Gå til Arrea.dk
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </main>
  );
};

export default YdelserPage;